import _toConsumableArray from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// 0, 2, 10, 30 second delays before reconnect attempts.
var DEFAULT_RETRY_DELAYS_IN_MILLISECONDS = [0, 2000, 10000, 30000, null];
/** @private */

export var DefaultReconnectPolicy = /*#__PURE__*/function () {
  function DefaultReconnectPolicy(retryDelays) {
    _classCallCheck(this, DefaultReconnectPolicy);

    this._retryDelays = retryDelays !== undefined ? [].concat(_toConsumableArray(retryDelays), [null]) : DEFAULT_RETRY_DELAYS_IN_MILLISECONDS;
  }

  _createClass(DefaultReconnectPolicy, [{
    key: "nextRetryDelayInMilliseconds",
    value: function nextRetryDelayInMilliseconds(retryContext) {
      return this._retryDelays[retryContext.previousRetryCount];
    }
  }]);

  return DefaultReconnectPolicy;
}();